import { Box, Typography } from '@mui/material';
import { Button } from 'common/components';
import * as icons from 'icons';
import { SnackBarAlertData } from 'modules/alerts/state';
import { useAppDispatch } from 'store';

import { DEFAULT_AUTO_HIDE_DURATION, useSnackbarAutoHide } from '../../hooks/useSnackbarAutoHide';
import { Snackbar } from './Snackbar';

type Props = {
  alertData: SnackBarAlertData;
};

export const SnackbarContainer = ({ alertData }: Props) => {
  const dispatch = useAppDispatch();
  const { severity, message } = alertData;
  const isAppAlertMessage = typeof message === 'object';
  const { action, actionLabel, icon, timeout = DEFAULT_AUTO_HIDE_DURATION } = isAppAlertMessage ? message : {};
  const isInfiniteMessage = timeout === 0;

  const { hide } = useSnackbarAutoHide(alertData, isInfiniteMessage ? null : timeout);

  const handleClose = timeout > DEFAULT_AUTO_HIDE_DURATION || isInfiniteMessage ? hide : undefined;

  const Icon = icon ? icons[icon] : undefined;

  const handleClick = () => {
    if (action) {
      dispatch(action);
    }
  };

  return (
    <Snackbar severity={severity} onClose={handleClose}>
      {Icon && (
        <Box fontSize="26px" height="26px">
          <Icon fontSize="inherit" />
        </Box>
      )}
      <Typography variant="natter-text-sm" lineHeight="26px">
        {isAppAlertMessage ? message.message : message}
      </Typography>
      {actionLabel && (
        <Button variant="text" onClick={handleClick}>
          {actionLabel}
        </Button>
      )}
    </Snackbar>
  );
};
